import { cn } from '@/lib/utils';

const PROTOCOL_LABELS: Record<string, string> = {
  wireguard: 'WireGuard',
  amneziawg: 'AmneziaWG',
  openvpn: 'OpenVPN',
  v2ray: 'V2Ray',
  shadowsocks: 'Shadowsocks',
  tor: 'Tor',
  coredns: 'CoreDNS',
};

export function ProtocolChip({
  protocol,
  enabled = true,
  className,
}: {
  protocol: string;
  enabled?: boolean;
  className?: string;
}): JSX.Element {
  const key = protocol.toLowerCase();

  return (
    <span
      className={cn(
        'inline-flex items-center rounded border border-border bg-secondary px-1.5 py-0.5 font-mono text-[10px] font-medium tracking-wide text-foreground/80',
        !enabled && 'opacity-40 line-through',
        className,
      )}
      title={enabled ? undefined : `${protocol} is disabled on this server`}
    >
      {PROTOCOL_LABELS[key] ?? protocol}
    </span>
  );
}
